<template>
  <b-container
    :class="[left ? 'components-left components-title' : 'components-title']"
  >
    <div :class="[all ? 'title-all' : '']">
      <h2>{{ title }}</h2>
      <span v-if="text">{{ text }}</span>
      <hr v-if="!all" />
    </div>
  </b-container>
</template>
<script>
export default {
  name: "titles",
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    },
    left: {
      type: Boolean,
      default: false
    },
    all: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" scoped></style>
